import { create } from "zustand";

export const GeneralConditionStore = create((set) => ({
  carroImage: null,
  energiaImage: null,
  aguaImage: null,
  carroValue: null,
  energiaValue: null,
  aguaValue: null,

  setCarroImage: (img) => set({ carroImage: img }),
  setEnergiaImage: (img) => set({ energiaImage: img }),
  setAguaImage: (img) => set({ aguaImage: img }),
  setCarroValue: (val) => set({ carroValue: val }),
  setEnergiaValue: (val) => set({ energiaValue: val }),
  setAguaValue: (val) => set({ aguaValue: val }),

  captacaoAguaImage: null,

  setCaptacaoAguaImage: (img) => set({ captacaoAguaImage: img }),

  fossaImage: null,
  lixoImage: null,
  esgotoImage: null,

  fossaValue: null,
  lixoValue: null,
  esgotoValue: null,

  setFossaImage: (img) => set({ fossaImage: img }),
  setLixoImage: (img) => set({ lixoImage: img }),
  setEsgotoImage: (img) => set({ esgotoImage: img }),

  setFossaValue: (val) => set({ fossaValue: val }),
  setLixoValue: (val) => set({ lixoValue: val }),
  setEsgotoValue: (val) => set({ esgotoValue: val }),

  reset: () =>
    set({
      carroValue: null,
      energiaValue: null,
      aguaValue: null,
      fossaValue: null,
      lixoValue: null,
      esgotoValue: null,
    }),
}));
